
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    blocks () {
      return this.post?.acf?.flexible_content_config?.content_blocks;
    },
    showDfp () {
      return this.post?.acf?.dfp_options?.dfp_options?.show_in_content;
    },
  },
  mounted () {
    if (this.showDfp) {
      this.renderDfp();
    }
  },
  methods: {
    renderDfp () {
      const dfp = document.createElement(`div`);
      dfp.classList.add(`max-article-width`, `px-1`, `py-2`, `ta-centre`);
      const leaderboardAd = this.siteSettings?.leaderboard_ad?.leaderboard_ad;
      const position = this.post.acf.dfp_options.override_position
        ? this.post.acf.dfp_options.position
        : this.$store.state.config.dfp_news_article_position;

      if (leaderboardAd) {
        dfp.id = leaderboardAd.element_id;
        const dfpScript = document.createElement(`script`);
        // set script innerhtml

        // NOTE: Following doesn't like being in a multiline template string
        dfpScript.innerHTML = `window.googletag = window.googletag || { cmd: [] };` +
          `window.googletag.pubads().refresh();` +
          `window.googletag.cmd.push(() => {` +
          `window.googletag.display('${leaderboardAd.element_id}');` +
          `});`;

        dfp.appendChild(dfpScript);

        const blocks = this.domQsa(`.flexible-content .flexible-content__block`);

        if (blocks.length < parseInt(position)) {
          blocks[blocks.length - 1].after(dfp);
        } else {
          blocks[parseInt(position) - 1].after(dfp);
        }

        this.renderContentScripts();
      }
    },
    renderContentScripts () {
      const scripts = document.querySelectorAll(`.flexible-content script`);
      scripts.forEach(target => {
        // Fine our parent element to append new script too
        const parent = target.parentElement;
        const script = document.createElement(`script`);

        // Build our new script, to append via appendChild which will execute the script
        script.type = target.type;
        script.src = (target.src) ? target.src : ``;
        script.innerHTML = target.innerHTML;

        // Remove non-initliased script and append our new script
        parent.removeChild(target);
        parent.appendChild(script);
      });
    },
    hasDarkBackground (block) {
      return block.background === `bg-grey500`;
    },
  },
};
